import Model  from '@/util/models';

export default class Matpel extends Model { 
    backend = '/master/matpel/'; 
    
    tingkats(params = {}){
        return this.api.get(this.backend + 'tingkats', params).then(res => {          
            return res.status == 200 ? res.data : [];
        });
    }
}

